/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'wo',
  [
    ['Sub', 'Ngo'],
    ,
  ],
  ,
  [
    ['Dib', 'Alt', 'Tal', 'Àla', 'Alx', 'Àjj', 'Ase'], ,
    ['Dibéer', 'Altine', 'Talaata', 'Àlarba', 'Alxamis', 'Àjjuma', 'Aseer'],
    ['Dib', 'Alt', 'Tal', 'Àla', 'Alx', 'Àjj', 'Ase']
  ],
  ,
  [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    ['Sam', 'Few', 'Mar', 'Awr', 'Mee', 'Suw', 'Sul', 'Ut', 'Sàt', 'Okt', 'Now', 'Des'],
    [
      'Samwiyee', 'Fewriyee', 'Mars', 'Awril', 'Mee', 'Suwe', 'Sulet', 'Ut', 'Sàttumbar',
      'Oktoobar', 'Nowàmbar', 'Desàmbar'
    ]
  ],
  , [['JC', 'AD'], , ['av. JC', 'AD']], 1, [6, 0],
  ['dd-MM-y', 'd MMM, y', 'd MMMM, y', 'EEEE, d MMM, y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'],
  [
    '{1} - {0}',
    ,
    '{1} \'ci\' {0}',
  ],
  [',', '.', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
  ['#,##0.###', '#,##0%', '¤ #,##0.00', '#E0'], 'CFA', 'Franc CFA bu Afrik Sowwu-jant', plural
];
